<template>
  <image-carousel
    v-if="getIsMobile"
    class="grid-gallery_mobile"
    :images="gallery_images"/>
  <div class="container" v-else>
    <gallery
      class="grid-gallery"
      :images="gallery_images"/>
  </div>
</template>

<script>

import Gallery from "../modules/Gallery/Gallery.vue";
import {mapGetters} from "vuex";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import PreviewArticle from "../parts/builder/PreviewArticle.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import uid_mixin from "../../mixins/uid_mixin";
import ImageCarousel from "./ImageCarousel.vue";

export default {
  name: "GridGallery",
  mixins: [uid_mixin],
  components: {ImageCarousel, LazyImage, Swiper, PreviewArticle, SwiperSlide, Gallery},
  props: {
    /**props**/
    img_src_1: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_1: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_1: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_2: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_2: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_2: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_3: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_3: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_3: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_4: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_4: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_4: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_5: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_5: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_5: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_6: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_6: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_6: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    img_src_7: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_7: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    gallery_img_src_7: {
      type: String,
      required: true,
      default: '',
      admin_type: 'image',
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    gallery_id() {
      return `grid_gallery-${this._uid}`
    },
    gallery_images() {
      return [
        {image_src: this.img_src_1, image_lazy_src: this.lazy_img_src_1, gallery_image: this.gallery_img_src_1},
        {image_src: this.img_src_2, image_lazy_src: this.lazy_img_src_2, gallery_image: this.gallery_img_src_2},
        {image_src: this.img_src_3, image_lazy_src: this.lazy_img_src_3, gallery_image: this.gallery_img_src_3},
        {image_src: this.img_src_4, image_lazy_src: this.lazy_img_src_4, gallery_image: this.gallery_img_src_4},
        {image_src: this.img_src_5, image_lazy_src: this.lazy_img_src_5, gallery_image: this.gallery_img_src_5},
        {image_src: this.img_src_6, image_lazy_src: this.lazy_img_src_6, gallery_image: this.gallery_img_src_6},
        {image_src: this.img_src_7, image_lazy_src: this.lazy_img_src_7, gallery_image: this.gallery_img_src_7},
      ]
    }
  }
}
</script>
